export interface ILandLordInfo {
  GivenName: string;
  SurName: string; //camelcase because its spelled like this in the API
  Domains: IDomain[];
  DomainSettings: IDomainSettings;
  PhoneNumbers?: string[];
}
export interface ITenantInfo {
  Email: string;
  PhoneNumbers: string[];
  Domains: IDomain[];
  DomainSettings: IDomainSettings;
  OccupationDate: number;
  NodeID: string;
}

export interface ITenantAccessStatus {
  canViewTemperature: boolean;
  canViewMeters: boolean;
  canViewHours: boolean;
  canViewBillingResults: boolean;
}

export interface IDomainSettings {
  TenantAccessStatus: ITenantAccessStatus;
  Currency: string;
  TimeZone: string;
  DefaultCulture: string;
}
export interface IDomain {
  Name: string;
  Code: string;
}

export interface IGetTenantResponse {
  OjectNumber: number;
  NodeID: string;
  Roles: string[];
  Email: string;
  PhoneNumbers: string[] | null;
  Domains: IDomain[];
  OccupationDate: number;
}

export interface IGetLandlordResponse {
  GivenName: string;
  SurName: string;
  Domains: IDomain[];
}

export const isLandlordTypeGuard = (tbd: any): tbd is IGetLandlordResponse => {
  if ((tbd as IGetLandlordResponse).GivenName) {
    return true;
  }
  return false;
};
